<template>
    <div class="user-message">
        <p>{{ displayedMessage }}</p>
    </div>
</template>

<script>
export default {
    name: 'UserMessage',
    props: {
        message: {
            type: String,
            required: true
        },
    },
    data() {
        return {
        displayedMessage: ''
        }
    },
    mounted() {
        this.displayedMessage = this.message
    }
}
</script>

<style lang="scss" scoped>
.user-message {
    display: inline-block;
    max-width: 400px;
    background-color: #1a1a1a;
    padding: 10px 20px;
    border-radius: 20px;
    color: #e6e6e6;

    p {
        margin: 0;
        white-space: pre-wrap;
        overflow-wrap: anywhere;
        word-break: break-word;
        hyphens: auto;
        line-height: 1.4;
    }
}
</style>
